import { render } from "./Edit.vue?vue&type=template&id=9ad415fc"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Items/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ad415fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ad415fc', __exports__)) {
    console.log('reload')
    api.reload('9ad415fc', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=9ad415fc", () => {
    console.log('re-render')
    api.rerender('9ad415fc', render)
  })

}


export default __exports__